package app.view

import app.api.CompaniesApi
import app.components.ModalStore
import app.components.buttonText
import app.components.warningModal
import app.model.Company
import app.svg.arrowDown
import app.svg.close
import app.svg.delete
import app.svg.edit
import dev.fritz2.core.*

data class CompanyEditState(
    val company: Company,
    val editName: String
)

fun RenderContext.companiesView(companiesApi: CompaniesApi) {
    val showCreateCompanyMenu = storeOf(false)
    val inputValue = storeOf("")
    val showModalStore = storeOf(ModalStore(show = false, message = ""))
    val editingCompany = storeOf<CompanyEditState?>(null)

    warningModal(modalStore = showModalStore)

    companiesApi.handler(Unit)
    companiesApi.data.render { companies ->
        div("flex flex-col gap-4 mt-4 dark:text-white") {
            if (companies.isEmpty()) {
                div("border rounded-lg p-4 dark:border-gray-700 dark:bg-gray-800") { +"No companies found" }
            }
            companies.forEach { company ->
                div("border rounded-lg p-4 flex group dark:border-gray-700 dark:bg-gray-800") {
                    editingCompany.data.render { editState ->
                        if (editState?.company?.id == company.id) {
                            div("flex flex-col gap-2 w-full") {
                                div("flex gap-2 items-center") {
                                    input(
                                        "border rounded-lg p-2 flex-1 dark:bg-gray-700 " +
                                                "dark:border-gray-600 dark:text-white dark:placeholder-gray-400"
                                    ) {
                                        value(editState.editName)
                                        changes.values() handledBy {
                                            editingCompany.update(
                                                editState.copy(editName = it)
                                            )
                                        }
                                    }
                                    div("flex gap-2") {
                                        button("px-2 py-1 bg-green-500 text-white rounded") {
                                            edit("size-6")
                                            clicks handledBy {
                                                companiesApi.putCompany(
                                                    Company(
                                                        id = company.id,
                                                        name = editState.editName
                                                    )
                                                )
                                                editingCompany.update(null)
                                            }
                                        }
                                        button("px-2 py-1 bg-gray-500 text-white rounded") {
                                            close("size-6")
                                            clicks handledBy {
                                                editingCompany.update(null)
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            div("flex items-center w-full") {
                                p("flex-1") { +company.name }
                                div("ml-auto invisible group-hover:visible flex gap-2") {
                                    button {
                                        edit("size-6")
                                        clicks handledBy {
                                            editingCompany.update(
                                                CompanyEditState(
                                                    company = company,
                                                    editName = company.name
                                                )
                                            )
                                        }
                                    }
                                    button {
                                        delete("size-6")
                                        clicks handledBy {
                                            showModalStore.update(
                                                ModalStore(
                                                    show = true,
                                                    message = "Are you sure you want to delete ${company.name}?",
                                                    onConfirm = { companiesApi.deleteCompany(company.id) }
                                                )
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        div("flex flex-col mt-4") {
            showCreateCompanyMenu.data.render { show ->
                div(if (!show) "hidden" else "w-full flex mb-4 gap-4") {
                    input(
                        "border w-full rounded-lg p-2 h-14 dark:bg-gray-700 " +
                                "dark:border-gray-600 dark:text-white dark:placeholder-gray-400"
                    ) {
                        placeholder("Company Name")
                        value(inputValue.data)
                        changes.values() handledBy inputValue.update
                    }
                    inputValue.data.render {
                        buttonText(
                            text = "Submit",
                            isDisabled = it == "",
                            onClick = {
                                companiesApi.postCompany(inputValue.current)
                                inputValue.update("")
                                showCreateCompanyMenu.update(false)
                            }
                        )
                    }
                }
                button("m-auto dark:text-white") {
                    clicks handledBy showCreateCompanyMenu.handle { it.not() }
                    title(if (!show) "Create Company" else "Close")
                    arrowDown(if (!show) "size-6" else "size-6 rotate-180")
                }
            }
        }
    }
}
